module.exports = __webpack_public_path__ + "static/media/SofiaProMedium.b307c6ce.otf";